import React, { useEffect, useState, createElement, Component } from 'react';
import { motion } from 'framer-motion';
import { Anchor, ArrowLeft, BookOpen, Calendar, CheckCircle2, ClipboardList, Heart, LifeBuoy, MessageCircle, Phone, Send, Shield, Sparkles, Target, TrendingUp, Trophy, User, Users, Waves, Wind } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
const WHATSAPP_PHONE = '972548800260';
const sessionStructure = [{
  title: 'פתיחה וחיבור',
  duration: '10-15 דק׳',
  description: 'חימום גופני, תרגול נשימות ושיח ממוקד לפתיחת הלב והכנת הקבוצה לפעילות.',
  icon: Heart
}, {
  title: 'פעילות חווייתית במים',
  duration: '55-60 דק׳',
  description: 'הדרכה מקצועית, תרגול אישי וקבוצתי על הסאפ, וחוויית הצלחה מוחשית בכל מפגש.',
  icon: Waves
}, {
  title: 'עיבוד וסיכום',
  duration: '10-15 דק׳',
  description: 'שיח קבוצתי המתרגם את "שפת המים" והתגובות על הסאפ לתובנות וכלים לחיים.',
  icon: ClipboardList
}];
const programMilestones = [{
  range: 'מפגשים 1-3',
  title: 'בניית בסיס ואמון',
  description: 'יצירת אמון במרחב החדש, ביסוס יציבה ושליטה ראשונית, וזיהוי דפוסי התמודדות במים והקבלתם למקרים בחיי היום יום.',
  color: 'bg-sky-50 border-sky-200 text-sky-900',
  dotColor: 'bg-sky-400'
}, {
  range: 'מפגשים 4-6',
  title: 'הנפילה כמשאב',
  description: 'התמודדות עם איבוד שליטה, עלייה חזרה לסאפ, ותרגול מיינדפולנס ושקט פנימי על המים.',
  color: 'bg-cyan-50 border-cyan-200 text-cyan-900',
  dotColor: 'bg-cyan-400'
}, {
  range: 'מפגשים 7-10',
  title: 'העצמה ועיגון',
  description: 'תקשורת ואמון הדדי בקבוצה, אתגרי העצמה אישיים וקבוצתיים, ושיח מסכם המעגן את הכלים שנרכשו.',
  color: 'bg-blue-50 border-blue-200 text-blue-900',
  dotColor: 'bg-blue-400'
}];
const programBenefits = [{
  icon: Wind,
  title: 'ויסות רגשי וגופני',
  description: 'עבודה ממוקדת על נשימה, קואורדינציה וריכוז.'
}, {
  icon: Target,
  title: 'שבירת דפוסי פחד',
  description: 'התמודדות הדרגתית ומבוקרת עם מצבי אתגר ואי-ודאות.'
}, {
  icon: Sparkles,
  title: 'חוויית מסוגלות מיידית',
  description: 'רגעים מוחשיים של הצלחה המעצימים את הדימוי העצמי.'
}, {
  icon: Users,
  title: 'ריפוי קבוצתי',
  description: 'מרחב מוגן ותומך המעודד אמון הדדי ותקשורת בין משתתפי הקבוצה.'
}];
const safetyStandards = [{
  icon: Users,
  title: 'ליווי מקצועי במים',
  description: 'לפחות שני מדריכים מנוסים נמצאים במים בכל פעילות לאורך כל הסדרה.'
}, {
  icon: LifeBuoy,
  title: 'ציוד קצה מותאם',
  description: 'סאפים ומשוטים חדישים, חגורות הצלה אישיות ורצועות ביטחון (ליש) מחוברות לכל אורך הפעילות.'
}, {
  icon: Shield,
  title: 'מעטפת בטיחותית',
  description: 'תדריך בטיחות קפדני לפני כל יציאה, והתאמה מלאה של תוואי החתירה לתנאי מזג האוויר.'
}];
const team = [{
  name: 'עדי שמעוני',
  role: 'מנחת קבוצות ויחידים, מדריכת סאפ מוסמכת',
  bio: 'מביאה מעולם משאבי האנוש והליווי האישי הבנה עמוקה בתהליכי התפתחות, שינוי ובניית חוסן. בשנים האחרונות מדריכת סאפ קבוצות ויחידים.',
  image: 'https://cdn.magicpatterns.com/uploads/7UQXFa8QVzGYPRJjgEmh4j/c61b37f1-fb9e-4cd8-b43e-2e77a03ab830_(1).jpg'
}, {
  name: 'נחום שחר',
  role: 'מטפל ברפואה סינית, מדריך סאפ ומטפל גוף-נפש',
  bio: 'מטפל ברפואה סינית מעל 25 שנה. מתמחה בחיבור בין תנועה במים לוויסות ואיזון מערכת העצבים, מתוך גישה אינטגרטיבית של גוף-נפש.',
  image: 'https://cdn.magicpatterns.com/uploads/wit9BigVU3kkgjKMJuGwc6/PHOTO-2026-06-02-11-27-41.jpg',
  imagePosition: '62% 6%'
}];
const personalProgramGoals = ['פיתוח ביטחון עצמי וחוסן נפשי באמצעות חוויות הצלחה והתגברות על אתגרים', 'חיזוק יכולות פיזיות ומוטוריות – שיפור שיווי משקל וקואורדינציה', 'טיפוח חיבור לטבע ולגוף באמצעות פעילות ימית חווייתית', 'פיתוח מיומנויות התמודדות עם מצבי לחץ, שינוי ואי־ודאות', 'חיזוק הקשר הבין־אישי עם המנחה ושילוב שיח רגשי מותאם', 'מניעת התדרדרות לפעילויות מסכנות או עברייניות'];
const personalProgramObjectives = ['חיזוק הקשר האישי בין המנחה למשתתף, תוך יצירת חוויות הצלחה מותאמות', 'פיתוח תחושת המסוגלות והעלאת הערך העצמי', 'שיפור כישורי חיים – קבלת החלטות, התמדה ושיתוף פעולה', 'הקניית כלים לשמירה על כללים וחוקים', 'הפחתת מצבי סיכון והגברת המוטיבציה להשתלבות חיובית בקהילה'];
const personalSuccessMetrics = ['נוכחות והתמדה בשיעור של 80% ומעלה', 'שיפור נצפה בשיתוף פעולה, התמדה וביטחון עצמי', 'ירידה בדיווחים על התנהגויות מסכנות', 'שביעות רצון גבוהה של המשתתפים והצוות המפנה'];
const personalSyllabus = [{
  number: 1,
  title: 'היכרות וביטחון ראשוני',
  points: ['יצירת קשר ואמון', 'היכרות עם הציוד וכללי בטיחות', 'התנסות בחתירה בישיבה/כריעה'],
  dialogue: '"מה נותן לי תחושת ביטחון?"'
}, {
  number: 2,
  title: 'עמידה והתקדמות',
  points: ['מעבר מישיבה לעמידה', 'טכניקת חתירה בסיסית בעמידה', 'שמירה על יציבות בתנועה'],
  dialogue: '"מה עזר לי לנסות משהו חדש?"'
}, {
  number: 3,
  title: 'שליטה וכיוון',
  points: ['חיזוק טכניקה והחזקת משוט נכונה', 'שינויי כיוון ובלימה', 'משימה: הגעה ליעד מוגדר במסלול'],
  dialogue: '"איך אני מתמודד כשמשהו לא הולך כמתוכנן?"'
}, {
  number: 4,
  title: 'נפילה וקימה',
  points: ['תרגול נפילה בטוחה', 'עלייה חזרה לסאפ במים עמוקים'],
  dialogue: '"חוויה אישית של נפילה ואיך קמתי ממנה"'
}, {
  number: 5,
  title: 'חתירה רציפה ואתגר אישי',
  points: ['מסלול חתירה ארוך יותר', 'הצבת יעד מותאם יכולת'],
  dialogue: '"מה מרגיש לי הישג?"'
}, {
  number: 6,
  title: 'שקט פנימי ומיינדפולנס במים',
  points: ['חתירה איטית ומודעת לנשימה', 'תרגילי שקט וקשב'],
  dialogue: '"איפה אני מוצא שקט בחיי?"'
}, {
  number: 7,
  title: 'משימת העצמה אישית',
  points: ['אתגר מותאם אישית (שיווי משקל, מרחק, טכניקה)'],
  dialogue: '"איך מתכוננים לאתגר? מה עוזר לי להצליח?"'
}, {
  number: 8,
  title: 'סיכום וחגיגה',
  points: ['חתירה המשלבת את כל הטכניקות שנלמדו', 'סיכום אישי של התהליך והדגשת חוזקות'],
  dialogue: '"מה אני לוקח איתי לחיים מהתהליך?"'
}];
const testimonials = [{
  quote: 'המים החזירו לי את השקט שהלך לאיבוד ב-7 באוקטובר. בפעם הראשונה אחרי הרבה זמן, הצלחתי לנשום נשימה עמוקה ולהרגיש את הגוף שלי בלי לרצות לברוח ממנו.',
  author: 'משתתפת',
  context: 'מקבוצת שורדי הנובה'
}, {
  quote: 'העבודה עם עדי ונחום מאפשרת למטופלים שלנו לעבור תהליך עומק שאף חדר טיפולים סגור לא יכול להציע. המקצועיות, הרגישות לטראומה וההתאמה האישית הן ברמה הגבוהה ביותר.',
  author: 'נציגת מחלקת הרווחה',
  context: 'עיריית צפת'
}];
export function SafeSpaceOnWaterPage() {
  const [form, setForm] = useState({
    fullName: '',
    organization: '',
    phone: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    document.title = "מרחב בטוח על המים - תוכניות חוסן | ביץ' קלאב מעגן";
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'תוכניות חוסן והעצמה על המים לעמותות, מחלקות רווחה וקרנות. תהליך מובנה של ויסות, חוסן ומסוגלות באמצעות סאפ, מיינדפולנס ועיבוד קבוצתי.');
  }, []);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.fullName.trim() || !form.phone.trim()) return;
    setIsSubmitting(true);
    // Open WhatsApp with prefilled message — same low-friction pattern used elsewhere on the site
    const text = encodeURIComponent(`היי, אני ${form.fullName}${form.organization ? ` מ-${form.organization}` : ''}.\nאני מתעניין/ת בתוכנית "מרחב בטוח על המים" עבור מטופלי הארגון שלנו.\n${form.message ? `\nפרטים: ${form.message}\n` : ''}\nטלפון: ${form.phone}${form.email ? `\nאימייל: ${form.email}` : ''}`);
    const url = `https://wa.me/${WHATSAPP_PHONE}?text=${text}`;
    window.open(url, '_blank', 'noopener,noreferrer');
    setSubmitted(true);
    setIsSubmitting(false);
  };
  return <div className="min-h-screen bg-slate-50 text-slate-900" dir="rtl" data-id="element-1501" data-mp="3a1t2n7cco9qn">
      <Navigation data-id="element-1502" data-mp="3pldv2wft4oqf" />

      {/* Hero */}
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden" data-id="element-1503" data-mp="3pkc6dp5vc3q8">
        <div className="absolute inset-0 z-0" data-id="element-1504" data-mp="3kmsugvwn831g">
          <img src="https://cdn.magicpatterns.com/uploads/pb2oCkPyfe9oskTmycrukm/89f10491-a91f-4aaa-9e3f-7c79bc220200.jpg" alt="קבוצה חותרת על סאפים בכנרת" className="w-full h-full object-cover" data-id="element-1505" data-mp="3kjyaf5hjkk8k" />
          <div className="absolute inset-0 bg-gradient-to-l from-slate-900/85 via-slate-900/75 to-sky-900/70" data-id="element-1506" data-mp="3bnfh3s5eeubg" />
        </div>

        <div className="relative z-10 container mx-auto px-4 max-w-5xl" data-id="element-1507" data-mp="31urmn41w52fw">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} data-id="element-1508" data-mp="31tghazssrmmo">
            <div className="inline-flex items-center gap-2 py-1.5 px-4 rounded-full bg-sky-400/15 border border-sky-300/40 text-sky-100 text-sm font-medium mb-6 backdrop-blur-sm" data-id="element-1509" data-mp="2rv0u37ww4xig">
              <Anchor className="w-4 h-4" data-id="element-1510" data-mp="2ix792t4ktqal" />
              <span data-id="element-1511" data-mp="yemx756njezi">תוכניות חוסן והעצמה למוסדות</span>
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6 max-w-4xl" data-id="element-1512" data-mp="ygh8rsw19uqx">
              מחזירים את העוגן לחיים:
              <br data-id="element-1513" data-mp="17ejjx19he3rx" />
              <span className="text-sky-200" data-id="element-1514" data-mp="17g490bd10uie">
                תוכניות חוסן מותאמות אישית על המים
              </span>
            </h1>
            <p className="text-lg md:text-xl text-slate-100 leading-relaxed max-w-3xl mb-6 font-light" data-id="element-1515" data-mp="1cc1roobricyc">
              מועדון הספורט הימי במעגן עדן מזמין עמותות, ארגונים ומחלקות רווחה
              להעניק למטופלים שלהם תהליך חווייתי וייחודי של התפתחות, חיבור לגוף
              ויציאה משיתוק לעשייה – באמצעות שילוב מובנה של חתירת סאפ,
              מיינדפולנס ועיבוד קבוצתי.
            </p>
            <p className="text-base md:text-lg text-sky-100 leading-relaxed max-w-3xl mb-10 font-light" data-id="element-1516" data-mp="tgl5xwz2o9cy">
              אנחנו מציעים סדרות מפגשים קבוצתיים לצד{' '}
              <span className="font-semibold text-white" data-id="element-1517" data-mp="y7j0sf9y7sn">
                מפגשי העצמה אישיים
              </span>{' '}
              — כל תוכנית נבנית באופן מותאם אישית לקהל היעד ולמטרות הארגון.
            </p>
            <a href="#contact" className="inline-flex items-center gap-2 bg-sky-500 hover:bg-sky-600 text-white text-base md:text-lg font-bold py-4 px-8 rounded-full transition-all shadow-xl shadow-sky-900/30 hover:scale-[1.02]" data-id="element-1518" data-mp="36jbqjr3lzk2q">
              לתאום פגישת ייעוץ
              <ArrowLeft className="w-5 h-5" data-id="element-1519" data-mp="2ivc2x01lg9sd" />
            </a>
          </motion.div>
        </div>
      </section>

      {/* Why Water & SUP */}
      <section className="py-20 md:py-24 bg-white" data-id="element-1520" data-mp="2nuwxky9qdvza">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-1521" data-mp="2sti2vc3ub5ul">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-1522" data-mp="2srx5zfu1zatk">
            <span className="inline-block text-sky-600 font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-1523" data-mp="202q7uhyign8u">
              הצורך והפתרון
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-1524" data-mp="1xitmhcsm41ny">
              למה דווקא מים וסאפ?
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="space-y-6 text-lg text-slate-700 leading-relaxed" data-id="element-1525" data-mp="1nlfhc9c52zay">
            <p data-id="element-1526" data-mp="1emlei187tcoy">
              כאשר מתמודדים עם פוסט-טראומה, חרדה או משברים נפשיים, לעיתים קרובות
              המילים לבדן אינן מספיקות.
              <span className="font-semibold text-slate-900" data-id="element-1527" data-mp="14v7iw4jdwx13">
                {' '}
                הטראומה נצרבת בגוף
              </span>
              , והדרך לחזור לתחושת שליטה וחוסן עוברת דרך תנועה, חוויית מסוגלות
              והתמודדות מבוקרת עם אי-ודאות.
            </p>
            <p data-id="element-1528" data-mp="uz4706yqdk0y">
              על גבי הסאפ, מול מרחבי הכנרת, המטופלים פוגשים את האלמנטים המשתנים
              של הטבע (רוח, גלים) בסביבה מוגנת לחלוטין.
            </p>
            <p data-id="element-1529" data-mp="g915ixzq8znn">
              כל שמירה על שיווי משקל, כל חתירה קדימה וכל עלייה חזרה לסאפ לאחר
              נפילה –{' '}
              <span className="font-semibold text-sky-700" data-id="element-1530" data-mp="l7ku765pgpjp">
                מתורגמות באופן מיידי לכלים פרקטיים, ביטחון עצמי וחוסן מנטלי
                בחיים עצמם.
              </span>
            </p>
          </motion.div>
        </div>
      </section>

      {/* Visual break — youth paddling on the Kinneret */}
      <section className="relative h-[260px] sm:h-[340px] md:h-[420px] overflow-hidden" data-id="element-1531" data-mp="100xtkdu6u451">
        <img src="https://cdn.magicpatterns.com/uploads/kTa2nmck7dQy3kE5LemFns/%D7%99%D7%9C%D7%93%D7%99%D7%9D.jpg" alt="בני נוער חותרים בשמחה על סאפים בכנרת" className="w-full h-full object-cover" data-id="element-1532" data-mp="1429hmexeyhb4" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 via-slate-900/10 to-transparent" data-id="element-1533" data-mp="v5qs7coe5bja" />
        <div className="absolute bottom-6 right-6 md:bottom-10 md:right-10 max-w-md text-white" data-id="element-1534" data-mp="1ivl7s203he78">
          <p className="text-base md:text-lg font-semibold leading-snug drop-shadow-md" data-id="element-1535" data-mp="1npz1lzz3zd9s">
            כשהאתגר הופך לחיוך – רגעי מסוגלות והצלחה על המים.
          </p>
        </div>
      </section>

      {/* Core Message — Tailored */}
      <section className="py-20 md:py-24 bg-gradient-to-b from-sky-50 to-slate-50" data-id="element-1536" data-mp="26t0ygk2ew1c9">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-1537" data-mp="21ty5vz3mbnl6">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-14" data-id="element-1538" data-mp="21ug616teilyd">
            <span className="inline-block text-sky-600 font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-1539" data-mp="1o29sztljov35">
              הייחודיות שלנו
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-1540" data-mp="1j2eyzh6h3pdv">
              תוכניות מותאמות אישית
            </h2>
            <p className="text-lg md:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed" data-id="element-1541" data-mp="2uic2caf26bum">
              אנחנו מאמינים בהקשבה לצרכים שלכם. הבסיס המקצועי שלנו נשען על
              תוכניות מובנות, אך כל סדרת מפגשים נבנית ומותאמת אישית לקהל היעד
              הספציפי של הקבוצה שלכם.
            </p>
          </motion.div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-1542" data-mp="1dz642wgv2k50">
            {programBenefits.map((b, i) => <motion.div key={b.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="bg-white rounded-2xl p-7 border border-slate-200 hover:border-sky-300 hover:shadow-lg transition-all" data-id="element-1543" data-mp="1i19hhqn3bysx" data-mpi={i}>
                <div className="w-12 h-12 rounded-xl bg-sky-100 flex items-center justify-center mb-4" data-id="element-1544" data-mp="21pice8g0qiw4">
                  <b.icon className="w-6 h-6 text-sky-600" data-id="element-1545" data-mp="25rdal42nkg5o" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1546" data-mp="2apf12a2erhr6">
                  {b.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-1547" data-mp="3v7zbdtkopl05">
                  {b.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Process Structure */}
      <section className="py-20 md:py-24 bg-white" data-id="element-1548" data-mp="3m7ko4oo5tvu0">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-1549" data-mp="3h8hkn8ntvxo5">
          {/* Program milestones — example */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-14" data-id="element-1550" data-mp="htckvwa9z0no">
            <span className="inline-block text-sky-600 font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-1551" data-mp="8z7x5lqfu5cd">
              המתודולוגיה
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-5 leading-tight" data-id="element-1552" data-mp="11gtpnisdkf7z">
              אבני הדרך לאורך הסדרה
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-1553" data-mp="wpbp2vu9kgnj">
              דוגמה ממבנה תוכנית בת 10 מפגשים, מותאמת באופן ספציפי לכל קבוצה
            </p>
          </motion.div>

          <div className="relative max-w-4xl mx-auto" data-id="element-1554" data-mp="1kkdnfctac5op">
            {/* Vertical line */}
            <div className="absolute top-0 bottom-0 right-6 md:right-1/2 md:translate-x-1/2 w-px bg-slate-200" data-id="element-1555" data-mp="16utq4mih40ms" />
            <div className="space-y-8" data-id="element-1556" data-mp="1aukdeg8sjymk">
              {programMilestones.map((m, i) => <motion.div key={m.range} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="relative flex gap-6 items-start" data-id="element-1557" data-mp="wvb8icq1cqxw" data-mpi={i}>
                  <div className={`relative z-10 shrink-0 w-12 h-12 rounded-full ${m.dotColor} ring-4 ring-white shadow-md flex items-center justify-center text-white font-bold`} data-id="element-1558" data-mp="rx9nvncyojkb">
                    {i + 1}
                  </div>
                  <div className={`flex-1 rounded-2xl border p-6 ${m.color}`} data-id="element-1559" data-mp="2m8g0qc9undov">
                    <div className="text-xs font-semibold tracking-wider uppercase opacity-70 mb-1" data-id="element-1560" data-mp="alckt88rux0r">
                      {m.range}
                    </div>
                    <h4 className="text-xl font-bold mb-2" data-id="element-1561" data-mp="kea7zropla5p">{m.title}</h4>
                    <p className="leading-relaxed opacity-90" data-id="element-1562" data-mp="fms52y34kzi3">
                      {m.description}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Personal Sessions — Additional Offering */}
      <section className="py-20 md:py-24 bg-gradient-to-b from-white via-sky-50/40 to-white" data-id="element-1563" data-mp="13c4arnz8upfn">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-1564" data-mp="yd04b53pf5t0">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-14" data-id="element-1565" data-mp="ydjcvv7gshud">
            <div className="inline-flex items-center gap-2 py-1.5 px-4 rounded-full bg-sky-100 border border-sky-200 text-sky-700 text-sm font-semibold mb-5" data-id="element-1566" data-mp="306hby8ru46nr">
              <User className="w-4 h-4" data-id="element-1567" data-mp="2j98t2yfw3gh1" />
              <span data-id="element-1568" data-mp="2j87hmsuyorys">מוצר נוסף • ליווי אישי</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-5 leading-tight" data-id="element-1569" data-mp="2o2bm95gr8nwp">
              מפגשי העצמה אישיים
            </h2>
            <p className="text-lg md:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed" data-id="element-1570" data-mp="1w9uf8gcal2c3">
              בנוסף לסדרת המפגשים הקבוצתיים, אנחנו מציעים מפגשי העצמה אישיים
              שתכליתם ללוות תהליכי התפתחות אישיים, להתמודד עם פחדים, להבין את
              מקורם ולהקנות כלים לחיים.
            </p>
            <p className="text-base text-slate-500 max-w-2xl mx-auto leading-relaxed mt-4 italic" data-id="element-1571" data-mp="2a9lwqr20p0uu">
              להלן דוגמה לסילבוס שנבנה לתוכנית בת 8 מפגשים — כל תוכנית נבנית
              באופן מותאם אישית למשתתף.
            </p>
          </motion.div>

          {/* Goals & Objectives — two columns */}
          <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-1572" data-mp="1a15sc8t9mupa">
            {/* Goals */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white border border-slate-200 rounded-3xl p-7 md:p-8 shadow-sm" data-id="element-1573" data-mp="152cci9qiarly">
              <div className="flex items-center gap-3 mb-5" data-id="element-1574" data-mp="vaos2ssdaatz">
                <div className="w-11 h-11 rounded-xl bg-sky-100 flex items-center justify-center" data-id="element-1575" data-mp="rbpdshkqx1pv">
                  <Target className="w-5 h-5 text-sky-600" data-id="element-1576" data-mp="mb1s8bfadd31" />
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-slate-900" data-id="element-1577" data-mp="hbymspve94uj">
                  מטרות התוכנית
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-1578" data-mp="cg1f17y756td">
                {personalProgramGoals.map((goal, i) => <li key={i} className="flex items-start gap-3" data-id="element-1579" data-mp="2bpzsnupd2s44" data-mpi={i}>
                    <div className="shrink-0 w-6 h-6 rounded-full bg-sky-50 border border-sky-200 flex items-center justify-center mt-0.5" data-id="element-1580" data-mp="26sr9bqsh8i1a">
                      <span className="text-xs font-bold text-sky-700" data-id="element-1581" data-mp="304dgt91qpw27">
                        {i + 1}
                      </span>
                    </div>
                    <span className="text-slate-700 leading-relaxed" data-id="element-1582" data-mp="2qbeg4ssyyf28">
                      {goal}
                    </span>
                  </li>)}
              </ul>
            </motion.div>

            {/* Objectives */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-white border border-slate-200 rounded-3xl p-7 md:p-8 shadow-sm" data-id="element-1583" data-mp="2hdcjepg9q8kr">
              <div className="flex items-center gap-3 mb-5" data-id="element-1584" data-mp="5m8l621h7rq7">
                <div className="w-11 h-11 rounded-xl bg-cyan-100 flex items-center justify-center" data-id="element-1585" data-mp="5lp40njnh7d8">
                  <TrendingUp className="w-5 h-5 text-cyan-600" data-id="element-1586" data-mp="1l563hr95zq1" />
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-slate-900" data-id="element-1587" data-mp="1jhh0u273o856">
                  יעדי התוכנית
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-1588" data-mp="1t81tza408kgp">
                {personalProgramObjectives.map((obj, i) => <li key={i} className="flex items-start gap-3" data-id="element-1589" data-mp="1tafnvfmy7qmo" data-mpi={i}>
                    <div className="shrink-0 w-6 h-6 rounded-full bg-cyan-50 border border-cyan-200 flex items-center justify-center mt-0.5" data-id="element-1590" data-mp="1x8dhcunr4yvv">
                      <span className="text-xs font-bold text-cyan-700" data-id="element-1591" data-mp="15ihbesbrjp7y">
                        {i + 1}
                      </span>
                    </div>
                    <span className="text-slate-700 leading-relaxed" data-id="element-1592" data-mp="19ij3c9rp54a1">
                      {obj}
                    </span>
                  </li>)}
              </ul>
            </motion.div>
          </div>

          {/* Success Metrics */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-sky-600 to-cyan-600 rounded-3xl p-7 md:p-10 mb-14 shadow-lg" data-id="element-1593" data-mp="2pyc8cvlib636">
            <div className="flex items-center gap-3 mb-6" data-id="element-1594" data-mp="lwu481zmd3o5">
              <div className="w-11 h-11 rounded-xl bg-white/15 backdrop-blur-sm flex items-center justify-center border border-white/20" data-id="element-1595" data-mp="zsxuxlbaatvv">
                <Trophy className="w-5 h-5 text-white" data-id="element-1596" data-mp="utcut7kdofhk" />
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-1597" data-mp="764tf0q2lqkt">
                מדדי הצלחה
              </h3>
            </div>
            <div className="grid sm:grid-cols-2 gap-4" data-id="element-1598" data-mp="gvejyc59n16t">
              {personalSuccessMetrics.map((metric, i) => <div key={i} className="flex items-start gap-3 bg-white/10 backdrop-blur-sm border border-white/15 rounded-2xl p-4" data-id="element-1599" data-mp="c4ofr28kt4dp" data-mpi={i}>
                  <CheckCircle2 className="w-5 h-5 text-sky-100 shrink-0 mt-0.5" data-id="element-1600" data-mp="3kjg6e6h8fosz" />
                  <span className="text-white font-medium leading-relaxed" data-id="element-1601" data-mp="3flwuvebx5q4q">
                    {metric}
                  </span>
                </div>)}
            </div>
          </motion.div>

          {/* Syllabus — 8 sessions */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-10" data-id="element-1602" data-mp="1zuujyeg0pfem">
            <div className="inline-flex items-center gap-2 text-sky-600 font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-1603" data-mp="1q4j7g3i9pxw4">
              <BookOpen className="w-4 h-4" data-id="element-1604" data-mp="2isyf24z2ldxf" />
              <span data-id="element-1605" data-mp="2irnf6g8qwqbl">הסילבוס</span>
            </div>
            <h3 className="text-2xl md:text-4xl font-bold text-slate-900 mb-3 leading-tight" data-id="element-1606" data-mp="24t5teo2ehnwb">
              דוגמה למבנה 8 מפגשים אישיים
            </h3>
            <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-1607" data-mp="29qxots297s59">
              כל מפגש משלב חוויה במים, התמודדות עם אתגר ושיח אישי מותאם.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-5" data-id="element-1608" data-mp="yddblz9kymcn">
            {personalSyllabus.map((session, i) => <motion.div key={session.number} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="group bg-white border border-slate-200 hover:border-sky-300 rounded-2xl p-6 transition-all hover:shadow-lg" data-id="element-1609" data-mp="1dna1rknrxw9m" data-mpi={i}>
                <div className="flex items-start gap-4 mb-4" data-id="element-1610" data-mp="1wlupd2qgijii">
                  <div className="shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-sky-500 to-cyan-500 text-white flex items-center justify-center font-bold text-lg shadow-md shadow-sky-500/20" data-id="element-1611" data-mp="1wj8dws0g3jv0">
                    {session.number}
                  </div>
                  <div className="flex-1 pt-1" data-id="element-1612" data-mp="1il1tadkibgda">
                    <div className="text-xs font-semibold tracking-wider uppercase text-sky-600 mb-1" data-id="element-1613" data-mp="c5r9oqxwt346">
                      מפגש {session.number}
                    </div>
                    <h4 className="text-lg font-bold text-slate-900 leading-tight" data-id="element-1614" data-mp="78r6cnsg2egr">
                      {session.title}
                    </h4>
                  </div>
                </div>

                <ul className="space-y-2 mb-4 pr-1" data-id="element-1615" data-mp="2ntcnsx57m82u">
                  {session.points.map((point, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-slate-700 leading-relaxed" data-id="element-1616" data-mp="2rt53dtt0tehp" data-mpi={idx}>
                      <div className="shrink-0 w-1.5 h-1.5 rounded-full bg-sky-400 mt-2" data-id="element-1617" data-mp="2wmpssxgjt05a" />
                      <span data-id="element-1618" data-mp="31k9f8knegj8b">{point}</span>
                    </li>)}
                </ul>

                <div className="pt-4 border-t border-slate-100" data-id="element-1619" data-mp="36ib0nc8asumy">
                  <div className="flex items-start gap-2" data-id="element-1620" data-mp="3bi5qdcgc7e6f">
                    <MessageCircle className="w-4 h-4 text-cyan-500 shrink-0 mt-0.5" data-id="element-1621" data-mp="3bgkr59j2v728" />
                    <div data-id="element-1622" data-mp="3fjhfzhz7nzem">
                      <div className="text-xs font-semibold text-slate-500 mb-0.5" data-id="element-1623" data-mp="1h4ny5c4zlt52">
                        שיח אישי
                      </div>
                      <p className="text-sm text-slate-700 italic leading-relaxed" data-id="element-1624" data-mp="1l7awzx02sebr">
                        {session.dialogue}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </div>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mt-12" data-id="element-1625" data-mp="2xi3ls7mx2nap">
            <a href="#contact" className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white text-base font-bold py-4 px-8 rounded-full transition-all shadow-xl shadow-slate-900/20 hover:scale-[1.02]" data-id="element-1626" data-mp="37eq4oqvon4a3">
              לתאום ייעוץ על מפגשים אישיים
              <ArrowLeft className="w-5 h-5" data-id="element-1627" data-mp="3c67y8tvdm2l1" />
            </a>
          </motion.div>
        </div>
      </section>

      {/* Safety */}
      <section className="py-20 md:py-24 bg-slate-900 text-white" data-id="element-1628" data-mp="3q725vaalnzin">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-1629" data-mp="3l87dbgmtywlc">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-14" data-id="element-1630" data-mp="3l5l65i3uqj3n">
            <div className="inline-flex items-center gap-2 py-1.5 px-4 rounded-full bg-sky-500/15 border border-sky-400/30 text-sky-200 text-sm font-medium mb-5" data-id="element-1631" data-mp="3vst8rewqt7gh">
              <Shield className="w-4 h-4" data-id="element-1632" data-mp="3mxkumc6vxgb" />
              <span data-id="element-1633" data-mp="3m280t0v6iqkw">בטיחות ללא פשרות</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-5 leading-tight" data-id="element-1634" data-mp="3m0n9dk45vnr9">
              כדי שתוכלו לשלוח את המטופלים בלב שקט
            </h2>
            <p className="text-lg text-slate-300 max-w-2xl mx-auto" data-id="element-1635" data-mp="3c5brisxgi0fa">
              אנו מחויבים לסטנדרטים המחמירים ביותר בכל היבטי הבטיחות במים.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-1636" data-mp="33447nfvot24q">
            {safetyStandards.map((s, i) => <motion.div key={s.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-slate-800/60 border border-slate-700 rounded-2xl p-7 backdrop-blur-sm" data-id="element-1637" data-mp="382yx30o5toxt" data-mpi={i}>
                <div className="w-12 h-12 rounded-xl bg-sky-500/15 border border-sky-400/30 flex items-center justify-center mb-4" data-id="element-1638" data-mp="3dl7ri8yrkvni">
                  <s.icon className="w-6 h-6 text-sky-300" data-id="element-1639" data-mp="34m43qronjs2o" />
                </div>
                <h3 className="text-lg font-bold text-white mb-3" data-id="element-1640" data-mp="34o75ua32xbnr">{s.title}</h3>
                <p className="text-slate-300 text-sm leading-relaxed" data-id="element-1641" data-mp="2ztt8410y2sfx">
                  {s.description}
                </p>
              </motion.div>)}
          </div>

          {/* Visual proof of safety — life vests on participants */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-12 relative rounded-3xl overflow-hidden border border-slate-700" data-id="element-1642" data-mp="2lvmpfs4kgz0u">
            <img src="https://cdn.magicpatterns.com/uploads/uNaUCPW3BbJoisw3idg4Ne/44430867-7980-4c61-9fd5-297d5b7addc5.jpg" alt="קבוצה עם חגורות הצלה מסודרת לפני יציאה למים" className="w-full h-64 md:h-80 object-cover" data-id="element-1643" data-mp="we7qur5k0f0d" />
            <div className="absolute inset-0 bg-gradient-to-l from-slate-900/70 via-slate-900/20 to-transparent" data-id="element-1644" data-mp="15dciremm1a3k" />
            <div className="absolute inset-0 flex items-center px-6 md:px-10" data-id="element-1645" data-mp="do9isb1ralwq">
              <p className="max-w-md text-white text-sm md:text-base font-medium leading-relaxed drop-shadow-md" data-id="element-1646" data-mp="dm6i8x2z9adr">
                כל יציאה למים מתחילה בתדריך בטיחות וציוד הצלה אישי לכל משתתף –
                הסביבה מוגנת לחלוטין, גם כשהאתגר אישי.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Team */}
      <section className="py-20 md:py-24 bg-white" data-id="element-1647" data-mp="3q4muvp10isxt">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-1648" data-mp="3v4hk7o553agr">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-14" data-id="element-1649" data-mp="3v2ws056as3m2">
            <span className="inline-block text-sky-600 font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-1650" data-mp="39rki16q6d5qg">
              הצוות המקצועי
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-5 leading-tight" data-id="element-1651" data-mp="30rxjcsotye13">
              האנשים שמובילים את התהליך
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-1652" data-mp="2quj4uymgvzbf">
            {team.map((member, i) => <motion.div key={member.name} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-slate-50 border border-slate-200 rounded-3xl overflow-hidden" data-id="element-1653" data-mp="2d3nxxrvj3sah" data-mpi={i}>
                {member.image ? <div className="relative h-64 overflow-hidden" data-id="element-1654" data-mp="2865nty5rz70w">
                    <img src={member.image} alt={member.name} className="w-full h-full object-cover" style={{
                objectPosition: member.imagePosition || '50% 50%'
              }} data-id="element-1655" data-mp="1oj1fni26saiv" />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent" data-id="element-1656" data-mp="1yhgzczyvwhic" />
                  </div> : <div className="relative h-64 overflow-hidden bg-gradient-to-br from-sky-100 via-sky-50 to-slate-100 flex items-center justify-center" data-id="element-1657" data-mp="1tgb16mmgg21f">
                    <div className="w-24 h-24 rounded-full bg-white/70 border border-sky-200 flex items-center justify-center shadow-sm" data-id="element-1658" data-mp="22iu04vn4duie">
                      <span className="text-3xl font-bold text-sky-700" data-id="element-1659" data-mp="2h6nfqgc7gx0z">
                        {member.name.charAt(0)}
                      </span>
                    </div>
                  </div>}
                <div className="p-7" data-id="element-1660" data-mp="2q8el1k2u31ub">
                  <h3 className="text-2xl font-bold text-slate-900 mb-1" data-id="element-1661" data-mp="2m69yf5asz5h6">
                    {member.name}
                  </h3>
                  <p className="text-sky-600 font-semibold text-sm mb-4" data-id="element-1662" data-mp="2ta9g69yld8xn">
                    {member.role}
                  </p>
                  <p className="text-slate-600 leading-relaxed" data-id="element-1663" data-mp="2y92uu5pm75ze">{member.bio}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Gallery mosaic — authentic moments from the field */}
      <section className="py-16 md:py-20 bg-slate-50" data-id="element-1664" data-mp="3bzzhlfwv0syj">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-1665" data-mp="3bzfyvwzdy0jg">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-10" data-id="element-1666" data-mp="3gyj53kr3qct0">
            <span className="inline-block text-sky-600 font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-1667" data-mp="3qw72yjk080fe">
              רגעים מהשטח
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-slate-900 leading-tight" data-id="element-1668" data-mp="1wj7fy5dao3y3">
              ככה זה נראה אצלנו על המים
            </h2>
            <p className="text-slate-600 mt-3 max-w-2xl mx-auto" data-id="element-1669" data-mp="dp4j17pcq714">
              תמונות אותנטיות ממפגשי הקבוצות והסדרות שלנו בכנרת
            </p>
          </motion.div>

          {/* Featured wide shot — community on the water */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="relative aspect-[16/7] overflow-hidden rounded-2xl border border-slate-200 group mb-4 md:mb-6" data-id="element-1670" data-mp="4w138sr8hi3b">
            <img src="https://cdn.magicpatterns.com/uploads/noLmPvWjr5SRoEyjmUkGZF/e74f9f3c-a78a-45c4-8dea-b0c7c0f86bca.jpg" alt="קבוצה גדולה חותרת יחד על סאפים בכנרת" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-1671" data-mp="sm508h9x2jlc" />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 via-transparent to-transparent" data-id="element-1672" data-mp="38dj5mko8lwwc" />
            <div className="absolute bottom-5 right-5 md:bottom-7 md:right-7 max-w-md" data-id="element-1673" data-mp="33cn0y4w2a6pv">
              <p className="text-white text-sm md:text-base font-semibold drop-shadow-md" data-id="element-1674" data-mp="v3nl5q5njkky">
                כוח הקבוצה — חתירה משותפת על הכנרת.
              </p>
            </div>
          </motion.div>

          {/* Mosaic grid — authentic field moments */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6" data-id="element-1675" data-mp="r34vo2r8eqlx">
            {[{
            src: 'https://cdn.magicpatterns.com/uploads/4EdwGkuFdCRT2x9p7TMsqn/d614f3cc-c15c-44ca-8678-26421fe3560a.jpg',
            alt: 'תרגול חימום ותנועה לפני יציאה למים'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/vHnihWkpAcZUcuKyj32dxq/GetAttachmentThumbnail_(5).jpg',
            alt: 'משתתפים על סאפים במים שקטים בזריחה'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/1ocePwf9rkmwuHh1H9pSRx/939A3565.jpg',
            alt: 'הסאפים מוכנים על החוף — שעת בוקר בכנרת'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/5nGxiXmrUekLw5TSXSsSo9/287d3c34-35e3-43a7-969b-4f2d0a812169.jpg',
            alt: 'רגע של שקט ומיינדפולנס על המים'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/nwAWSPsL8aY4Qi2gmods16/GetAttachmentThumbnail_(6).jpg',
            alt: 'מבט על החוף והציוד — הבית של הסדרות שלנו'
          }].map((img, i) => <motion.div key={img.src} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="relative aspect-[4/3] overflow-hidden rounded-2xl border border-slate-200 group" data-id="element-1676" data-mp="3r26276vmvxrz" data-mpi={i}>
                <img src={img.src} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-1677" data-mp="3d480p22evvtw" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1678" data-mp="2kl2d48a5t6cg" />
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 md:py-24 bg-gradient-to-b from-slate-50 to-sky-50" data-id="element-1679" data-mp="oiplkfnoj9yi">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-1680" data-mp="ogmnr9gaccj8">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-14" data-id="element-1681" data-mp="taqt5o9wkci7">
            <span className="inline-block text-sky-600 font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-1682" data-mp="ml8f1iumnid">
              מן השטח
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-5 leading-tight" data-id="element-1683" data-mp="aieubbigjtct">
              עדויות וסיפורי הצלחה
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-1684" data-mp="ei6twypvip61">
            {testimonials.map((t, i) => <motion.div key={t.author} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white border border-slate-200 rounded-3xl p-8 shadow-sm" data-id="element-1685" data-mp="1lxtqwe6r8j7e" data-mpi={i}>
                <div className="text-6xl font-serif text-sky-200 leading-none mb-2" data-id="element-1686" data-mp="31ow099n0clve">
                  "
                </div>
                <p className="text-lg text-slate-800 leading-relaxed mb-6 -mt-4" data-id="element-1687" data-mp="2wpjc8lkeh8r8">
                  {t.quote}
                </p>
                <div className="flex items-center gap-3 pt-4 border-t border-slate-100" data-id="element-1688" data-mp="2rp54z5qmi2u9">
                  <div className="w-10 h-10 rounded-full bg-sky-100 flex items-center justify-center" data-id="element-1689" data-mp="2mqtuqtwf1qbi">
                    <Heart className="w-5 h-5 text-sky-600" data-id="element-1690" data-mp="2isnqbsj1vmtr" />
                  </div>
                  <div data-id="element-1691" data-mp="2dtb336o9odqn">
                    <div className="font-bold text-slate-900" data-id="element-1692" data-mp="2dtt92v0qe6br">{t.author}</div>
                    <div className="text-sm text-slate-500" data-id="element-1693" data-mp="gyeyea6rwao1">{t.context}</div>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section id="contact" className="py-20 md:py-24 bg-white scroll-mt-20" data-id="element-1694" data-mp="3h2ht2mp5wg2n">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-1695" data-mp="3lyf6ol91j8bq">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-10" data-id="element-1696" data-mp="37b3vwlkonsco">
            <span className="inline-block text-sky-600 font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-1697" data-mp="2y8uq290d0n5m">
              נדבר בהמשך
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-5 leading-tight" data-id="element-1698" data-mp="2obpyturnq1hy">
              בואו נבנה יחד את מרחב הצמיחה הבא
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed max-w-2xl mx-auto" data-id="element-1699" data-mp="2tat5tkr76hsk">
              השאירו פרטים, ונחזור אליכם כדי לתאם פגישה (בזום או על כוס קפה מול
              הכנרת אצלנו במועדון), לשמוע על הצרכים הייחודיים של הארגון שלכם
              ולגבש תוכנית מותאמת.
            </p>
          </motion.div>

          {submitted ? <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="bg-emerald-50 border border-emerald-200 rounded-3xl p-10 text-center" data-id="element-1700" data-mp="2725liezgvtm0">
              <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4" data-id="element-1701" data-mp="2gzs2r848nx95">
                <CheckCircle2 className="w-8 h-8 text-emerald-600" data-id="element-1702" data-mp="2uqouyxu96cfo" />
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-1703" data-mp="2pteu8m1eyecj">
                תודה! פתחנו עבורך וואטסאפ
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-1704" data-mp="34pe3i009ekj9">
                המשיכי את ההודעה בוואטסאפ עם הפרטים הקצרים שמילאת, ונחזור אלייך
                בהקדם.
              </p>
            </motion.div> : <motion.form onSubmit={handleSubmit} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-slate-50 border border-slate-200 rounded-3xl p-8 md:p-10 space-y-5" data-id="element-1705" data-mp="1aceqmen9k4fo">
              <div className="grid md:grid-cols-2 gap-5" data-id="element-1706" data-mp="21fl6jvpkfecy">
                <div data-id="element-1707" data-mp="2gbu3gqlzhfm7">
                  <label className="block text-sm font-semibold text-slate-700 mb-1.5" data-id="element-1708" data-mp="2gcca8h69vc8d">
                    שם מלא <span className="text-sky-600" data-id="element-1709" data-mp="2bb6bo2pxkuqx">*</span>
                  </label>
                  <input type="text" name="fullName" value={form.fullName} onChange={handleChange} required disabled={isSubmitting} className="w-full bg-white border border-slate-200 rounded-xl py-3 px-4 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-sky-300 transition-all" data-id="element-1710" data-mp="2pb7dbke0s67g" />
                </div>
                <div data-id="element-1711" data-mp="2u4sbpdjiz276">
                  <label className="block text-sm font-semibold text-slate-700 mb-1.5" data-id="element-1712" data-mp="38277r14aa884">
                    שם העמותה / הארגון
                  </label>
                  <input type="text" name="organization" value={form.organization} onChange={handleChange} disabled={isSubmitting} placeholder="עמותה, מחלקת רווחה, קרן..." className="w-full bg-white border border-slate-200 rounded-xl py-3 px-4 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-sky-300 transition-all" data-id="element-1713" data-mp="342gb4gs2sxvo" />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-5" data-id="element-1714" data-mp="3ipopfqgoljbv">
                <div data-id="element-1715" data-mp="33xmu8jpk3ei6">
                  <label className="block text-sm font-semibold text-slate-700 mb-1.5" data-id="element-1716" data-mp="33x4ngt59phw0">
                    טלפון <span className="text-sky-600" data-id="element-1717" data-mp="38qz5ls585osz">*</span>
                  </label>
                  <input type="tel" name="phone" value={form.phone} onChange={handleChange} required disabled={isSubmitting} placeholder="050-1234567" dir="ltr" className="w-full bg-white border border-slate-200 rounded-xl py-3 px-4 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-sky-300 transition-all text-right" data-id="element-1718" data-mp="2uz186ekvlhcn" />
                </div>
                <div data-id="element-1719" data-mp="vjq2cww1qmjc">
                  <label className="block text-sm font-semibold text-slate-700 mb-1.5" data-id="element-1720" data-mp="vjzkjyaunpeh">
                    אימייל
                  </label>
                  <input type="email" name="email" value={form.email} onChange={handleChange} disabled={isSubmitting} placeholder="name@example.com" dir="ltr" className="w-full bg-white border border-slate-200 rounded-xl py-3 px-4 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-sky-300 transition-all text-right" data-id="element-1721" data-mp="mq4pxk7cthd3" />
                </div>
              </div>

              <div data-id="element-1722" data-mp="15gcl9g4tb3iq">
                <label className="block text-sm font-semibold text-slate-700 mb-1.5" data-id="element-1723" data-mp="15fksed2lnjw5">
                  ספרו לנו על הצורך
                </label>
                <textarea name="message" value={form.message} onChange={handleChange} disabled={isSubmitting} rows={4} placeholder="קהל היעד, גודל הקבוצה, מה הייתם רוצים להשיג..." className="w-full bg-white border border-slate-200 rounded-xl py-3 px-4 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-sky-300 transition-all resize-none" data-id="element-1724" data-mp="10k5jlzjg8e6l" />
              </div>

              <button type="submit" disabled={isSubmitting} className="w-full inline-flex items-center justify-center gap-2 bg-sky-600 hover:bg-sky-700 text-white font-bold py-4 rounded-2xl transition-all shadow-lg shadow-sky-600/20 hover:scale-[1.01] disabled:opacity-70" data-id="element-1725" data-mp="3l2j2fcd1q294">
                <Send className="w-5 h-5" data-id="element-1726" data-mp="3twxgxcpr58r6" />
                שליחת פרטים – נשמח לדבר
              </button>

              <p className="text-center text-xs text-slate-500 pt-1" data-id="element-1727" data-mp="2q3128qe1zq1">
                לחיצה תפתח שיחת וואטסאפ עם הפרטים שמילאת
              </p>
            </motion.form>}

          {/* Direct contact */}
          <div className="mt-10 flex flex-wrap items-center justify-center gap-6 text-slate-600" data-id="element-1728" data-mp="29eptu903kb7t">
            <a href={`https://wa.me/${WHATSAPP_PHONE}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-emerald-600 transition-colors" data-id="element-1729" data-mp="2edsznvnwilgu">
              <MessageCircle className="w-5 h-5" data-id="element-1730" data-mp="8rmu3rakzidr" />
              שליחת הודעה ישירה בוואטסאפ
            </a>
            <span className="text-slate-300" data-id="element-1731" data-mp="3ss1xyqq4hgz">•</span>
            <a href="tel:0548800260" className="inline-flex items-center gap-2 hover:text-sky-600 transition-colors" data-id="element-1732" data-mp="hox8hlip3nmw">
              <Phone className="w-5 h-5" data-id="element-1733" data-mp="crx219hxoiv9" />
              054-8800260
            </a>
          </div>
        </div>
      </section>

      <Footer data-id="element-1734" data-mp="3l4kwkhyxn8kt" />
    </div>;
}